<!--label for="fname">Enter Text To Be Translated:</label &nbsp;  -->
<!--input #textToBeTranslated &nbsp;&nbsp;  --> 

<form [formGroup]="mainForm" *ngIf="showForm" (ngSubmit)="setAllAsTouched() && mainForm.valid && clicked()" >
  <div  *ngIf="!mainForm.controls['textToBeTranslated'].valid && (mainForm.controls['textToBeTranslated'].touched)" class="input-field col s6">
    <p style="color:red">*Text To Translate is Required*</p>
  </div>
<div class="input-field col s6">
    <input id="textToBeTranslated" name="textToBeTranslated" [formControl]="mainForm.controls['textToBeTranslated']" type="text" class="validate" #textToBeTranslated>
    <label for="textToBeTranslated">Enter Text To Be Translated:</label>
  </div>
  <!-- *ngIf="mainForm.submitted && !mainForm.controls['source'].valid && (mainForm.controls['source'].touched)" -->
  <!--*ngIf="!mainForm.controls['source'].valid && (mainForm.controls['source'].touched)"-->
  <!--div  *ngIf="!mainForm.controls['source'].valid && (mainForm.controls['source'].touched)" class="input-field col s6"-->
  <div  *ngIf="!mainForm.controls['source'].valid && (mainForm.controls['source'].touched)" class="input-field col s6">
    <p style="color:red">*Source is Required*</p>
  </div>
 <div class="input-field col s12">
    <label for="languages" style="position: relative" >Enter Source:</label>
    <select id="source"  name="source" style="border-style: solid; border-color: red;display: block;" [formControl]="mainForm.controls['source']"  name="source"> 
     
        <option *ngFor="let language of languages_list" >{{language}}</option>
    </select> 
  </div>
  <div  *ngIf="!mainForm.controls['target'].valid && (mainForm.controls['target'].touched)" class="input-field col s6">
    <p style="color:red">*Target is Required*</p>
  </div>
 <div class="input-field col s12">
  <label for="target" style="position: relative" >Enter Target:</label>
  <select id="target" name="target" style="border-style: solid; border-color: red;display: block;" [formControl]="mainForm.controls['target']"  name="target"> 
   
      <option *ngFor="let language of languages_list" >{{language}}</option>
  </select> 
</div>

<br>
<Button id="b1" type="sumbit" name="submit"  >{{buttonDisplay}}</Button>
<app-displayresult [buttonChildText]="translatedText"></app-displayresult>
</form>